import { defineMessages } from 'react-intl';

export const ReadingGroupsPage = defineMessages({
  header: {
    id: 'app.readingGroups.header',
    defaultMessage: 'Seznam odečtových skupin',
  },
  create: {
    id: 'app.readingGroups.create',
    default: 'Vytvořit odečtovou skupinu',
  },
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
});

export const ReadingGroupsTableColumns = defineMessages({
  id: {
    id: 'app.common.id',
    defaultMessage: 'ID',
  },
  name: {
    id: 'app.common.name',
    defaultMessage: 'Název',
  },
  description: {
    id: 'app.common.description',
    defaultMessage: 'Popis',
  },
  meterCount: {
    id: 'app.readingGroups.meterCount',
    defaultMessage: 'Počet měřidel',
  },
  search: {
    id: 'app.common.search',
    defaultMessage: 'Hledat',
  },
  reset: {
    id: 'app.common.reset',
    defaultMessage: 'Zrušit',
  },
  actions: {
    id: 'app.common.actions',
    defaultMessage: 'Akce',
  },
  confirmDelete: {
    id: 'app.readingGroups.confirmDelete',
    defaultMessage: 'Opravdu chcete smazat odečtovou skupinu?',
  },
});

export const GroupDetailCard = defineMessages({
  name: {
    id: 'app.common.name',
    defaultMessage: 'Název',
  },
  nameIsRequired: {
    id: 'app.common.nameIsRequired',
    defaultMessage: 'Název je povinný',
  },
  groupNameInput: {
    id: 'app.readingGroups.groupNameInput',
    defaultMessage: 'Zadejte název odečtové skupiny',
  },
  description: {
    id: 'app.common.description',
    defaultMessage: 'Popis',
  },
  groupDescriptionInput: {
    id: 'app.readingGroups.groupDescriptionInput',
    defaultMessage: 'Zadejte popis odečtové skupiny',
  },
  metersTechnology: {
    id: 'app.common.metersTechnology',
    defaultMessage: 'Technologie měřidel',
  },
  selectTechnology: {
    id: 'app.common.selectMetersTechnology',
    defaultMessage: 'Vyberte technologii',
  },
  saveChanges: {
    id: 'app.common.saveChanges',
    defaultMessage: 'Uložit změny',
  },
});

export const CreateReadingGroupPage = defineMessages({
  header: {
    id: 'app.readingGroups.createHeader',
    defaultMessage: 'Vytvořit novou odečtovou skupinu',
  },
});

export const ReadingGroupDetailPage = defineMessages({
  header: {
    id: 'app.readingGroups.detailHeader',
    defaultMessage: 'Odečtová skupina {name}',
  },
  detailTitle: {
    id: 'app.readingGroups.detailTitle',
    defaultMessage: 'Detail odečtové skupiny',
  },
  metersPanel: {
    id: 'app.common.meters',
    defaultMessage: 'Měřidla',
  },
});

export const AddMeterForm = defineMessages({
  title: {
    id: 'app.readingGroups.addMeterTitle',
    defaultMessage: 'Přidat měřidlo do odečtové skupiny',
  },
  meterApiKeyLabel: {
    id: 'app.common.meterApiKey',
    defaultMessage: 'API klíč měřidla',
  },
  meterApiKeyTooltip: {
    id: 'app.readingGroups.meterApiKeyTooltip',
    defaultMessage: 'Naskenujte QR kód nebo zadejte API klíč měřidla',
  },
  meterApiKeyPlaceholder: {
    id: 'app.readingGroups.meterApiKeyPlaceholder',
    defaultMessage: 'Naskenujte QR kód nebo zadejte API klíč',
  },
  strapiIdLabel: {
    id: 'app.common.strapiId',
    defaultMessage: 'StrapiId',
  },
  strapiIdTooltip: {
    id: 'app.readingGroups.strapiIdTooltip',
    defaultMessage: 'Zadejte Strapi ID ze systému',
  },
  strapiIdPlaceholder: {
    id: 'app.readingGroups.strapiIdPlaceholder',
    defaultMessage: 'Zadejte ID měřidla',
  },
  validatorRequired: {
    id: 'app.readingGroups.meterRequired',
    defaultMessage: 'Zadejte API klíč nebo ID měřidla',
  },
  scanSuccess: {
    id: 'app.readingGroups.qrScanSuccess',
    defaultMessage: 'QR kód byl úspěšně naskenován',
  },
  findError: {
    id: 'app.readingGroups.findError',
    defaultMessage: 'Špatně zadané Strapi ID / API klíč',
  },
  notFound: {
    id: 'app.readingGroups.notFound',
    defaultMessage: 'Měřidlo nebylo nalezeno',
  },
  alreadyInGroup: {
    id: 'app.readingGroups.alreadyInGroup',
    defaultMessage: 'Měřidlo je již ve skupině',
  },
  cancel: {
    id: 'app.common.cancel',
    defaultMessage: 'Zrušit',
  },
  addMeter: {
    id: 'app.readingGroups.addMeter',
    defaultMessage: 'Přidat měřidlo',
  },
});

export const GroupMetersTable = defineMessages({
  tableTitle: {
    id: 'app.readingGroups.metersTableTitle',
    defaultMessage: 'Měřidla v odečtové skupině',
  },
  columnId: {
    id: 'app.common.id',
    defaultMessage: 'ID',
  },
  columnName: {
    id: 'app.common.name',
    defaultMessage: 'Název',
  },
  columnType: {
    id: 'app.common.type',
    defaultMessage: 'Typ',
  },
  columnActions: {
    id: 'app.common.actions',
    defaultMessage: 'Akce',
  },
  deleteConfirm: {
    id: 'app.readingGroups.deleteMeterConfirm',
    defaultMessage: 'Opravdu chcete odebrat toto měřidlo ze skupiny?',
  },
  delete: {
    id: 'app.common.delete',
    defaultMessage: 'Odebrat',
  },
  noData: {
    id: 'app.readingGroups.noMeters',
    defaultMessage: 'V odečtové skupině nejsou žádná měřidla.',
  },
  cancel: {
    id: 'app.common.cancel',
    defaultMessage: 'Zrušit',
  },
});

export const ReadingGroupsHooks = defineMessages({
  locationError: {
    id: 'app.readingGroups.locationError',
    defaultMessage: 'Nebyla vybrána lokalita',
  },
  findGroupsError: {
    id: 'app.readingGroups.findGroupsError',
    defaultMessage: 'Nepodařilo se načíst odečtové skupiny',
  },
  updateGroupSuccess: {
    id: 'app.readingGroups.updateGroupSuccess',
    defaultMessage: 'Odečtová skupina byla úspěšně aktualizována',
  },
  updateGroupError: {
    id: 'app.readingGroups.updateGroupError',
    defaultMessage: 'Nepodařilo se aktualizovat odečtovou skupinu',
  },
  success: {
    id: 'app.readingGroups.createSuccess',
    defaultMessage: 'Odečtová skupina byla úspěšně vytvořena',
  },
  deleteGroupSuccess: {
    id: 'app.readingGroups.deleteSuccess',
    defaultMessage: 'Odečtová skupina byla odstraněna',
  },
  deleteGroupError: {
    id: 'app.readingGroups.deleteError',
    defaultMessage: 'Nepodařilo se odstranit odečtovou skupinu',
  },
});
